import { useAtomValue } from 'jotai'

import {
  showValidationResultsAtom,
  validationResultsAtom
} from 'Automations/automationEditor/atoms'

type UseNodeHasValidationResults = (props: { nodeId: string }) => boolean

export const useNodeHasValidationResults: UseNodeHasValidationResults = ({
  nodeId
}) => {
  const validationResults = useAtomValue(validationResultsAtom)
  const showValidationResults = useAtomValue(showValidationResultsAtom)

  if (!showValidationResults) return false

  const resultsForNodeId = validationResults[nodeId]
  if (!resultsForNodeId) return false

  const hasValidationResults = Object.keys(resultsForNodeId).some(fieldId => {
    return resultsForNodeId[fieldId].length > 0
  })

  return hasValidationResults
}
